import React from "react";
import { skills } from "../../data/skills";

const SkillsStrip = () => {
  return (
    <section className="scroll-mt-24 pt-4" aria-label="Skills">
      <ul className="m-0 flex list-none flex-wrap items-center justify-center gap-x-5 gap-y-6 p-0">
        {skills.map((skill) => (
          <li key={skill.id} className="group relative flex flex-col items-center">
            <img
              src={skill.src}
              alt={skill.name}
              className="h-5 w-5 object-contain opacity-40 grayscale transition-opacity group-hover:opacity-70 dark:opacity-35 dark:group-hover:opacity-55"
            />
            <span
              role="tooltip"
              className="pointer-events-none absolute top-full mt-1.5 whitespace-nowrap rounded px-1.5 py-0.5 text-[10px] font-medium tracking-wide text-zinc-500 opacity-0 transition-opacity duration-150 group-hover:opacity-100 dark:text-zinc-400"
            >
              {skill.name}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SkillsStrip;
